// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__30oEx","rootSmall":"AddTileButton_rootSmall__b10ru"};